import { render } from "./FineFatturazioneView.vue?vue&type=template&id=4bcff597&scoped=true"
import script from "./FineFatturazioneView.vue?vue&type=script&lang=js"
export * from "./FineFatturazioneView.vue?vue&type=script&lang=js"

import "./FineFatturazioneView.vue?vue&type=style&index=0&id=4bcff597&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcff597"]])

export default __exports__